import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { ContactsParams } from 'src/apis/organisation-service/types';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import {
  OrganisationDetailsRequest,
  useOrganisationDetails,
} from 'src/pages/settings/organisation/company-information/use-organisation-details';
import { useContact } from 'src/pages/settings/organisation/contacts/edit/use-contact';
import { useContacts } from 'src/pages/settings/organisation/contacts/use-contacts';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';
import { Forbidden } from 'src/utils/errors';

const contactsParams: ContactsParams = {
  limit: 0, // we just need the edit link
};

const Page = lazy(() => import('./page'));

type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export const EditContact: FC<Props> = ({ organisationService }) => {
  if (!organisationService.response.data._links.getMyOrganisationDetails)
    throw new Forbidden();

  const organisationDetails = useOrganisationDetails({
    url: organisationService.response.data._links.getMyOrganisationDetails.href,
  });

  if (!organisationDetails.response) return <PageSpinner />;

  return <LoadContact organisationDetails={organisationDetails} />;
};

const LoadContact: FC<{
  organisationDetails: Successful<OrganisationDetailsRequest>;
}> = ({ organisationDetails }) => {
  if (!organisationDetails.response.data._links.contacts) throw new Forbidden();

  const { contactId } = useParams<{ contactId: string }>();

  const contacts = useContacts({
    url: organisationDetails.response.data._links.contacts.href,
    params: contactsParams,
  });
  const contact = useContact({ contactId, contacts });

  if (!contact.response) return <PageSpinner />;

  return <Page contact={contact} />;
};
